import { Vue2 as Vue } from 'vue-demi';
import EmojiPicker from './EmojiPicker.vue';

// Mounts a Vue 2 picker into a DOM node. Caller must call destroy()
// on the returned handle when it's done.
function mountEmojiPicker(el, { onSelect, i18n } = {}) {
  if (!el) {
    throw new Error('mountEmojiPicker: target element is required');
  }

  // Vue replaces the mount target; wrap in a child so the caller's
  // container survives across mount/destroy cycles.
  const inner = document.createElement('div');
  el.appendChild(inner);

  const EmojiPickerCtor = Vue.extend(EmojiPicker);
  const instance = new EmojiPickerCtor({
    propsData: { i18n: i18n || {} },
  });
  instance.$on('select', (emoji) => {
    if (typeof onSelect === 'function') {
      onSelect(emoji);
    }
  });
  instance.$mount(inner);

  return {
    destroy() {
      instance.$destroy();
      if (instance.$el && instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el);
      }
    },
  };
}

// Knockout uses a custom loader that doesn't go through webpack, so
// expose via window for the KO bridge to reach.
window.twa = window.twa || {};
window.twa.emojiPicker = { mount: mountEmojiPicker };

export default mountEmojiPicker;
